import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getRombelPortalusers, addRombel } from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';
import Table from '../../../ui/Table';
import DetailItem from '../../../app/common/layout/DetailItem';
import { sortArrayObject } from '../../../app/common/helpers/objectHelpers';

const mapState = (state, ownProps) => {
  let portalusers = state.rombels.portalusers;
  let classyears = state.rombels.classyears;
  return {
    portalusers,
    classyears,
  };
};

const actions = {
  closeModal,
  getRombelPortalusers,
  addRombel,
};

function ModalPreviewAddRombel({
  data,
  portalusers,
  classyears,
  getRombelPortalusers,
  addRombel,
  closeModal,
}) {
  const auth = data.auth;
  const history = data.history;
  const item = data.item;
  const [state, setState] = useState({
    sortStudents: [],
    conflictStudentsInRombels: [],
  });
  const [count, setCount] = useState(10);
  let sortSetting = item.sortAbsence === 'NIS' ? 'nis' : 'name';

  const teachers = item.teachers;
  const jenjang = item.jenjang;
  const kelas = item.kelas;
  const year = item.year;
  const sem = item.sem;

  useEffect(() => {
    if (!state.conflictStudentsInRombels?.[0]) return;
    let timer = setTimeout(() => {
      setCount(count > 0 ? count - 1 : 0);
    }, 1000);

    return () => clearTimeout(timer);
  }, [count, state.conflictStudentsInRombels]);

  useEffect(() => {
    getRombelPortalusers({ auth, history, year: item.year });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const arrNis = item.nis;
    let students = [];
    for (let i = 0; i < arrNis.length; i++) {
      const nis = arrNis[i];
      const student =
        portalusers?.[0] && portalusers?.find((p) => p.nis + '' === nis + '');
      students = [...students, student];
    }

    let filterStudents = students.filter((item) => {
        return item !== null && typeof item === 'object' && Object.keys(item).length > 0;
      });

    let sortStudents =
      (filterStudents?.[0] &&
        sortArrayObject(filterStudents, sortSetting, 'asc')) ||
      [];

    let updateSortStudents = [];
    for (let i = 0; i < sortStudents.length; i++) {
      let updateSortStudent = sortStudents[i];
      updateSortStudents = [
        ...updateSortStudents,
        {
          ...updateSortStudent,
          noabsen: i + 1,
          status: updateSortStudent?.name ? 'OK' : 'No Data',
        },
      ];
    }
    // get conflict student that already registerd in other rombels
    let conflictStudentsInRombels = [];
    for (let i = 0; i < classyears.length; i++) {
      const cy = classyears[i];
      let students = cy.students && JSON.parse(cy.students);
      for (let j = 0; j < arrNis.length; j++) {
        const n = arrNis[j];
        let cs = students?.[0] && students.find((s) => s.nis + '' === n + '');
        if (cs)
          conflictStudentsInRombels = [
            ...conflictStudentsInRombels,
            {
              jenjang: cy.jenjang,
              kelas: cy.kelas,
              year: cy.year,
              sem: cy.sem,
              ...cs,
            },
          ];
      }
    }

    setState({
      ...state,
      sortStudents: [...updateSortStudents],
      conflictStudentsInRombels,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [classyears, item, portalusers, sortSetting]);

  function handleSubmit() {
    try {
      const sortStudents = state.sortStudents;
      const conflictSR = state.conflictStudentsInRombels;

      // Filter class years based on specified criteria
      const filteredClassyears = classyears?.map((cy) => {
        if (!cy || !cy.students) return cy;
        let updateStudents = [];
        if (sem + '' === '2' && cy.sem + '' === '2') {
          const students = JSON.parse(cy.students);
          updateStudents = students.filter((s) => {
            const conflict = conflictSR?.find(
              (cs) => cs.nis + '' === s.nis + ''
            );
            return !conflict;
          });
        } else if (
          sem + '' === '1' &&
          (cy.sem + '' === '1' || cy.sem + '' === '2')
        ) {
          let students2 = JSON.parse(cy.students);
          updateStudents = students2.filter((s) => {
            const conflict = conflictSR?.find(
              (cs) => cs.nis + '' === s.nis + ''
            );
            return !conflict;
          });
        } else {
          let students3 = JSON.parse(cy.students);
          updateStudents = students3;
        }

        return {
          ...cy,
          students: JSON.stringify(
            updateStudents.map((s, index) => ({ ...s, noabsen: index + 1 }))
          ),
        };
      });

      // Distribute class years by semester
      const sem1Classyears = [];
      const sem2Classyears = [];
      const restClassyears = [];
      filteredClassyears.forEach((cy) => {
        if (
          cy.jenjang + '' === jenjang + '' &&
          cy.kelas + '' === kelas + '' &&
          cy.year + '' === year + ''
        ) {
          if (cy.sem + '' === 1 + '') sem1Classyears.push(cy);
          else if (cy.sem + '' === 2 + '') sem2Classyears.push(cy);
        } else restClassyears.push(cy);
      });

      // Update or create class years based on semester
      let updatedClassyears = [];
      if (sem + '' === '1') {
        const checkSem1 = sem1Classyears[0] || {
          status: 'new',
          jenjang,
          kelas,
          year,
          sem: 1,
        };
        const students1 = checkSem1.students
          ? JSON.parse(checkSem1.students)
          : [];
        const updateStudents1 = sortArrayObject(
          [...students1, ...sortStudents],
          sortSetting,
          'asc'
        );
        updatedClassyears.push({
          ...checkSem1,
          students: JSON.stringify(
            updateStudents1.map((s, index) => ({ ...s, noabsen: index + 1 }))
          ),
          teachers: teachers ? JSON.stringify(teachers) : checkSem1.teachers,
        });
        const checkSem2 = sem2Classyears[0] || {
          status: 'new',
          jenjang,
          kelas,
          year,
          sem: 2,
        };
        const students2 = checkSem2.students
          ? JSON.parse(checkSem2.students)
          : [];
        const updateStudents2 = sortArrayObject(
          [...students2, ...sortStudents],
          sortSetting,
          'asc'
        );
        updatedClassyears.push({
          ...checkSem2,
          students: JSON.stringify(
            updateStudents2.map((s, index) => ({ ...s, noabsen: index + 1 }))
          ),
          teachers: teachers ? JSON.stringify(teachers) : checkSem2.teachers,
        });
      } else if (sem + '' === '2') {
        const checkSem2 = sem2Classyears[0] || {
          status: 'new',
          jenjang,
          kelas,
          year,
          sem: 2,
        };
        const students = checkSem2.students
          ? JSON.parse(checkSem2.students)
          : [];
        const updateStudents = sortArrayObject(
          [...students, ...sortStudents],
          sortSetting,
          'asc'
        );
        updatedClassyears.push({
          ...checkSem2,
          students: JSON.stringify(
            updateStudents.map((s, index) => ({ ...s, noabsen: index + 1 }))
          ),
          teachers: teachers ? JSON.stringify(teachers) : checkSem2.teachers,
        });
      }
      updatedClassyears = [...updatedClassyears, ...restClassyears];

      addRombel({
        auth,
        history,
        values: {
          jenjang,
          kelas,
          year,
          sem,
          classyears: updatedClassyears,
        },
      });
      closeModal();
    } catch (error) {
      console.error('Error in handle submit: ', error);
    }
  }

  let yearTitle = item?.yearTitle;
  let semTitle = item?.semTitle;
  let jenjangTitle = item?.jenjangTitle;
  let kelasTitle = item?.kelasTitle;
  let renderTeachers =
    item.teachers &&
    item.teachers[0] &&
    item.teachers.map((t, index) => (
      <span className='mr-1' key={index}>
        {t?.name}
        {item.teachers.length - 1 === index ? '' : ', '}
      </span>
    ));

  return (
    <Modal label='Preview Rombel' variant='info' closeModal={closeModal}>
      <div
        style={{
          height: 600,
          overflow: 'auto',
        }}
      >
        <div className='flex flex-column my-4 mx-1'>
          <div className='notification is-info is-light is-size-7'>
            <DetailItem
              width={100}
              item='Tahun Ajaran'
              detail={yearTitle ?? ''}
            />
            <DetailItem width={100} item='Semester' detail={semTitle ?? ''} />
            <DetailItem
              width={100}
              item='Jenjang'
              detail={jenjangTitle ?? ''}
            />
            <DetailItem width={100} item='Kelas' detail={kelasTitle ?? ''} />
            <DetailItem
              width={100}
              item='Wali Kelas'
              detail={renderTeachers ?? ''}
            />
          </div>
        </div>
        <div className='table-container mb-5'>
          <Table cols={2}>
            <Table.Header>
              <th className='has-text-centered middle' style={{ width: 100 }}>
                No Absen
              </th>
              <th className='has-text-centered middle' style={{ width: 90 }}>
                NIS
              </th>
              <th className='has-text-centered middle' style={{ width: 100 }}>
                NISN
              </th>
              <th className='has-text-left middle pl-3' style={{ width: 200 }}>
                Siswa
              </th>
              <th className='has-text-centered middle' style={{ width: 100 }}>
                Keterangan
              </th>
            </Table.Header>
            <Table.Body
              data={state?.sortStudents}
              render={(item, index) => (
                <ItemRow
                  portalusers={portalusers}
                  key={index}
                  index={index}
                  item={item}
                  conflictStudentsInRombels={state.conflictStudentsInRombels}
                />
              )}
            />
          </Table>
        </div>
      </div>
      <div className='flex justify-end align-center pt-3'>
        <div className='buttons'>
          <Button
            counter={
              state.conflictStudentsInRombels?.[0] && count ? count : false
            }
            disabled={
              state.conflictStudentsInRombels?.[0] && count > 0 ? true : false
            }
            cvariant='csave'
            onClick={handleSubmit}
          />
          <Button cvariant='cback' onClick={closeModal} />
        </div>
      </div>
    </Modal>
  );
}

function ItemRow({ index, item, conflictStudentsInRombels }) {
  let conflictStudents = conflictStudentsInRombels.filter(
    (cs) => cs.nis + '' === item.nis + ''
  );
  return (
    <tr style={{ fontSize: 14 }}>
      <td className='middle has-text-centered'>{item.noabsen}</td>
      <td className='middle has-text-centered'>{item?.nis}</td>
      <td className='middle has-text-centered'>{item?.nisn}</td>
      <td className='middle has-text-left pl-3'>{item?.name}</td>
      <td className='middle has-text-centered'>
        {!conflictStudents?.[0] && (
          <>
            {item?.status === 'OK' ? (
              <span className='has-text-info has-text-weight-semibold'>OK</span>
            ) : (
              <span className='has-text-danger has-text-weight-semibold'>
                No Data
              </span>
            )}
          </>
        )}
        {conflictStudents?.[0] && 'Sudah diset rombel: '}
        {conflictStudents?.[0] &&
          conflictStudents.map((cs, index) => (
            <span
              key={index}
              className='tag is-danger is-light is-rounded mb-1'
            >
              Kelas: {cs.kelas}, Sem: {cs.sem}
            </span>
          ))}
      </td>
    </tr>
  );
}

export default connect(mapState, actions)(ModalPreviewAddRombel);
